import {createStyles, makeStyles, Theme} from '@material-ui/core';
import {WHITE} from "../../../const/colors";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        tabsBar: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'nowrap',
            gap: 8,
            padding: '16px',
            [theme.breakpoints.up('md')]: {
                padding: '16px 47px',
                backgroundColor: theme.palette.primary.main,
            },
        },
        selectButtonsWrapperReducedWidth: {
            maxWidth: 'calc(100% - 10px)'
        },
        tabsContainer: {
            flex: 1,
        },
        selectButton: {
            flex: '0 1 180px',
        },
        closeIconButton: {
            color: WHITE,
            width: '22px',
            height: '22px',
            cursor: 'pointer',
            marginLeft: 28
        }
    }),
);

export default useStyles;
